import { Component, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { TuiButton } from '@taiga-ui/core';

/**
 * Bare-bones chrome for the external viewer. Renders a single top navigation bar
 * with the Context logo on the far left and an exit action on the far right, then
 * hosts the active viewer ({@link ExternalFileViewComponent} /
 * {@link ExternalFolderViewComponent}) through the router outlet.
 *
 * Unlike the portal there is intentionally no side navigation - external viewers
 * only ever see the shared content they were linked to.
 */
@Component({
	standalone: true,
	selector: 'ctx-viewer-shell',
	imports: [RouterOutlet, TranslocoModule, TuiButton],
	styles: `
		:host {
			header {
				background-color: var(--context-color-green-10);
			}
		}
	`,
	templateUrl: 'viewer-shell.component.html',
	host: { class: 'flex flex-col h-screen w-screen overflow-hidden' },
})
export class ViewerShellComponent {
	private readonly router = inject(Router);

	/**
	 * "Logs out" the external viewer and sends them back to the portal. The
	 * {@link LogoutComponent} clears the share session before redirecting.
	 */
	readonly onExit = () => this.router.navigate(['/logout']);
}
